// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sYixhlqV_5bIau {
  margin-left: var(--ds-space-500, 40px);
}
.KfLDwvJuocH1GA {
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  list-style: none;
}
.KfLDwvJuocH1GA li {
  position: relative;
  padding: var(--ds-space-025, 2px) var(--ds-space-0, 0);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.KfLDwvJuocH1GA li a {
  display: block;
  position: relative;
  padding: var(--ds-space-075, 6px) var(--ds-space-1000, 80px) var(--ds-space-075, 6px) var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-100, 3px);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.KfLDwvJuocH1GA li a:hover {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-neutral, #091e4224);
}
.KfLDwvJuocH1GA li .pHCI7eNrcMlaEs {
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.jrfvQOun8VbACp {
  padding: var(--ds-space-025, 2px);
  font-size: 16px;
  line-height: 20px;
}
`, ""]);
// Exports
export var ulGutter = `sYixhlqV_5bIau`;
export var orgList = `KfLDwvJuocH1GA`;
export var itemName = `pHCI7eNrcMlaEs`;
export var itemIcon = `jrfvQOun8VbACp`;
export default ___CSS_LOADER_EXPORT___;
